import identity from 'transmute/identity';
import debounce from 'transmute/debounce';
// @ts-expect-error file is untyped
import { createAction } from 'flux-actions';
import { DOCUMENT_SUMMARY_FETCH_SUCCEEDED, DOCUMENT_SUMMARY_FETCH_FAILED, DOCUMENT_VISITORS_FETCH_STARTED, DOCUMENT_VISITORS_FETCH_SUCCEEDED, DOCUMENT_VISITORS_FETCH_FAILED, DOCUMENT_REVISITS_FETCH_SUCCEEDED, DOCUMENT_REVISITS_FETCH_FAILED, REUPLOAD_PROGRESS_PERCENT, REUPLOAD_PROGRESS_PERCENT_CHIRP } from 'documents-lib/js/constants/ActionTypes';
import * as DocumentsApi from 'documents-ui/api/DocumentsApi';
export const reuploadProgressPercentAction = createAction(REUPLOAD_PROGRESS_PERCENT, identity);
export const reuploadProgressPercentChirpAction = createAction(REUPLOAD_PROGRESS_PERCENT_CHIRP, identity);
export const fetchDocumentSummarySuccess = createAction(DOCUMENT_SUMMARY_FETCH_SUCCEEDED, identity);
export const fetchDocumentSummaryFailure = createAction(DOCUMENT_SUMMARY_FETCH_FAILED, identity);
export const fetchDocumentVisitorsStarted = createAction(DOCUMENT_VISITORS_FETCH_STARTED, identity);
export const fetchDocumentVisitorsSuccess = createAction(DOCUMENT_VISITORS_FETCH_SUCCEEDED, identity);
export const fetchDocumentVisitorsFailure = createAction(DOCUMENT_VISITORS_FETCH_FAILED, identity);
export const fetchDocumentRevisitsSuccess = createAction(DOCUMENT_REVISITS_FETCH_SUCCEEDED, identity);
export const fetchDocumentRevisitsFailure = createAction(DOCUMENT_REVISITS_FETCH_FAILED, identity);
const debouncedSearch = debounce(300, (dispatch, {
  deckId,
  offset,
  documentVisitorSearchQuery,
  limit
}) => {
  return DocumentsApi.searchDocumentVisitors({
    deckId,
    offset,
    documentVisitorSearchQuery,
    limit
  }).then(visitorData => {
    dispatch(fetchDocumentVisitorsSuccess({
      documentVisitorSearchQuery,
      visitorData
    }));
  }).catch(() => {
    dispatch(fetchDocumentVisitorsFailure({
      documentVisitorSearchQuery
    }));
  });
});
export const reuploadProgressPercent = reuploadData => dispatch => dispatch(reuploadProgressPercentAction(reuploadData));
export const reuploadProgressPercentChirp = reuploadData => dispatch => dispatch(reuploadProgressPercentChirpAction(reuploadData));
export const fetchDocumentMetadata = deckId => dispatch => {
  return DocumentsApi.fetchDocumentMetadata(deckId).then(documentSummary => dispatch(fetchDocumentSummarySuccess(documentSummary)), () => dispatch(fetchDocumentSummaryFailure()));
};
export const fetchDocumentVisitors = ({
  deckId,
  offset = 0,
  documentVisitorSearchQuery = '',
  initial = false,
  limit = DocumentsApi.VISITORS_PAGE_LIMIT
}) => dispatch => {
  dispatch(fetchDocumentVisitorsStarted({
    documentVisitorSearchQuery,
    initial
  }));
  if (documentVisitorSearchQuery !== '') {
    // eslint-disable-next-line @typescript-eslint/no-floating-promises
    debouncedSearch(dispatch, {
      deckId,
      offset,
      documentVisitorSearchQuery,
      limit
    });
  } else {
    DocumentsApi.fetchDocumentVisitors({
      deckId,
      offset,
      limit
    }).then(visitorData => dispatch(fetchDocumentVisitorsSuccess({
      documentVisitorSearchQuery,
      visitorData
    }))).catch(() => {
      dispatch(fetchDocumentVisitorsFailure({
        documentVisitorSearchQuery
      }));
    });
  }
};
export const fetchDocumentRevisits = ({
  deckId,
  vid
}) => dispatch => {
  DocumentsApi.fetchDocumentRevisits({
    deckId,
    vid
  }).then(revisitsData => dispatch(fetchDocumentRevisitsSuccess({
    deckId,
    vid,
    revisitsData
  })), () => dispatch(fetchDocumentRevisitsFailure())).catch(error => {
    console.error(error);
  });
};